import React from "react";
import cx from "classnames";

const GenericCheckbox = ({
  label,
  checked,
  id,
  onChange,
  className = "",
  labelClassName = "",
  labelSize = 17,
}) => {
  return (
    <div className={className}>
      <div className="gkit-check">
        <input
          className="gkit-check-input"
          type="checkbox"
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label
          className={cx(
            "gkit-check-label",
            labelSize ? `gkit-p-${labelSize}` : "gkit-p-17",
            labelClassName
          )}
          htmlFor={id}
        >
          {label}
        </label>
      </div>
    </div>
  );
};

export default GenericCheckbox;
